'use client'

import { Download, Loader2 } from 'lucide-react'
import { useState } from 'react'
import { toast } from 'sonner'

import { PageHeaderActionTertiary } from '@/components/navigation/page-header-actions'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { downloadProfilePdf } from '@/lib/download-profile-pdf'

export type ProfilePdfDownloadButtonProps = {
  profileId: string
  label?: string
}

export function ProfilePdfDownloadButton({
  profileId,
  label = 'Export to PDF',
}: ProfilePdfDownloadButtonProps) {
  const [busy, setBusy] = useState(false)

  const onClick = async () => {
    setBusy(true)
    try {
      await downloadProfilePdf(profileId)
      toast.success('PDF exported')
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Failed to export PDF')
    } finally {
      setBusy(false)
    }
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <PageHeaderActionTertiary
          type="button"
          aria-label={label}
          onClick={() => void onClick()}
          disabled={busy}
        >
          {busy ? (
            <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
          ) : (
            <Download className="h-4 w-4" aria-hidden />
          )}
        </PageHeaderActionTertiary>
      </TooltipTrigger>
      <TooltipContent>{busy ? 'Exporting to PDF…' : label}</TooltipContent>
    </Tooltip>
  )
}
